import { Phone, ArrowRight, Sparkles } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const CTASection = () => {
  return (
    <section 
      className="section-dark text-center"
      style={{ 
        background: 'linear-gradient(180deg, var(--bg-wood) 0%, var(--bg-dark) 100%)'
      }}
    >
      <div className="container max-w-3xl">
        {/* Price Reminder */}
        <div className="mb-8">
          <div 
            className="inline-block price-tag pulse-gold"
            style={{ padding: '1.5rem 3rem' }}
          >
            <div className="flex items-center justify-center gap-2 mb-2">
              <Sparkles size={20} />
              <span className="text-sm uppercase tracking-widest">Limited Time Offer</span>
              <Sparkles size={20} />
            </div>
            <div className="text-4xl md:text-5xl font-bold mb-1">
              ₹{companyInfo.startingPrice}
            </div>
            <div className="text-xs opacity-80">
              Starting price • One-time investment
            </div>
          </div>
        </div>

        <h2 className="heading-hero text-gold mb-4">
          Ready to End Your Wood Borer Problem?
        </h2>
        
        <p 
          className="body-large mb-8"
          style={{ color: 'var(--text-muted)' }}
        >
          Don't let wood borers destroy your precious furniture. One call is all it takes 
          to get started with South Mumbai's most advanced wood borer treatment.
        </p>

        {/* Main CTA */}
        <div className="flex flex-col items-center gap-4">
          <a 
            href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
            className="btn-gold"
            style={{ 
              padding: '1.25rem 2.5rem',
              fontSize: '1.125rem'
            }}
          >
            <Phone size={22} />
            <span>Call {companyInfo.phone} Now</span>
            <ArrowRight size={22} />
          </a>
          <span 
            className="mono-text text-sm"
            style={{ color: 'var(--text-muted)' }}
          >
            Visitation + Inspection + Estimation charges are ₹1,999 (waived off in 1st booking) • By Appointment Only • South Mumbai
          </span>
        </div>

        {/* Service Areas */}
        <div 
          className="mt-12 pt-8"
          style={{ borderTop: '1px solid var(--border-gold)' }}
        >
          <p 
            className="body-small mb-4"
            style={{ color: 'var(--text-muted)' }}
          >
            Serving all of South Mumbai
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {['Colaba', 'Cuffe Parade', 'Malabar Hill', 'Worli', 'Lower Parel'].map((area, index) => (
              <span 
                key={index} 
                className="mono-text text-sm px-3 py-1 rounded"
                style={{ 
                  color: 'var(--gold-primary)',
                  background: 'rgba(212, 168, 75, 0.1)',
                  border: '1px solid var(--border-gold)'
                }}
              >
                {area}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
